module.exports = __webpack_public_path__ + "static/media/Header_BG.833ddaa8.jpg";